import React, { useEffect, useState, useRef } from 'react';
import { motion } from 'framer-motion';

interface AnimatedHeadingSequenceProps {
 headings?: string[];
 className?: string;
 interval?: number;
}

const AnimatedHeadingSequence: React.FC<AnimatedHeadingSequenceProps> = ({
 headings = [""],
 className = '',
 interval = 2500
}) => {
 const [currentIndex, setCurrentIndex] = useState(0);
 const [isAnimating, setIsAnimating] = useState(true);
 const [lineWidth, setLineWidth] = useState(0);
 const headingRef = useRef<HTMLHeadingElement>(null);

 useEffect(() => {
   const timer = setInterval(() => {
     setIsAnimating(false);
     setTimeout(() => {
       setCurrentIndex((prev) => (prev + 1) % headings.length);
       setIsAnimating(true);
     }, 100);
   }, interval);

   return () => clearInterval(timer);
 }, [headings, interval]);

 useEffect(() => {
   if (headingRef.current) {
     setLineWidth(headingRef.current.offsetWidth);
   }
 }, [currentIndex, headings[currentIndex]]);

 return (
   <div className="relative">
     <motion.div
       key={currentIndex}
       initial={{ opacity: 0, y: 20 }}
       animate={{ opacity: 1, y: 0 }}
       exit={{ opacity: 0, y: -20 }}
       className="relative"
     >
       <h1 ref={headingRef} className={className}>
         {headings[currentIndex]}
       </h1>
       <motion.svg 
         className="absolute -bottom-2 left-0"
         width={lineWidth}
         height="10"
         viewBox={`0 0 ${lineWidth} 10`}
       >
         <motion.path
           d={`M0 5 
             C${lineWidth * 0.2} ${8}, 
             ${lineWidth * 0.4} ${2}, 
             ${lineWidth * 0.6} ${8} 
             S${lineWidth * 0.8} ${2}, 
             ${lineWidth} ${5}`}
           stroke="#91A93D"
           strokeWidth="4"
           fill="none"
           strokeLinecap="round"
           initial={{ pathLength: 0 }}
           animate={{ pathLength: 1 }}
           transition={{
             duration: 0.4,
             ease: "easeOut"
           }}
         />
       </motion.svg>
     </motion.div>
   </div>
 );
};

export default AnimatedHeadingSequence;